/**
 * File track-secondary-cta-clicked.js.
 * Handles firing Segment events when secondary CTAs are clicked
 */

const secondaryCtas = document.querySelectorAll('.secondary-cta');

const handleSecondaryCtaClick = (e) => {
  const secondaryCta = e.target;
  const secondaryCtaLocation = window.location.href;
  const secondaryCtaText = secondaryCta.textContent;
  const secondaryCtaHref = secondaryCta.getAttribute('href');
  const secondaryCtaIndex = Array.from(secondaryCtas).indexOf(secondaryCta);

  const buttonLocation = secondaryCta.closest('.header') ? 'header' :
                         secondaryCta.closest('.hero, .referral, .landing-page') ? 'hero' :
                         secondaryCta.closest('.switch') ? 'bottom' :
                         'communication';

  const moduleAttributes = getModuleTrackingAttributes(secondaryCta);
  const moduleData = extractModuleData(moduleAttributes);

  let properties = {
    interaction_type: "INTERACTION_TYPE_SECONDARY_CTA_CLICKED",
    interaction_details: {
      location: secondaryCtaLocation,
      action_detail: secondaryCtaText,
      additional_data: [
        {
          key: "cta_href",
          value: secondaryCtaHref
        },
        {
          key: "cta_index",
          value: secondaryCtaIndex
        },
      ],
    },
  }

  if (typeof segmentGenericEvent === 'function') {
    segmentGenericEvent('track', properties);
  }

  // Analytics SDK double fire
  fireAnalyticsEvent(Track.WebItemClicked, {
    unique_id: 'secondary_cta_clicked',
    label: secondaryCtaText,
    element_type: 'ELEMENT_TYPE_BUTTON',
    item_value: secondaryCtaHref,
    item_details: {
      "secondary_cta_clicked": {
        module: {
          ...moduleData,
        },
        "cta_type": 'enrollment',
        "cta_index": String(secondaryCtaIndex),
        "button_location": buttonLocation,
      }
    }
  });
}

// Init
if (secondaryCtas.length > 0) {
  for (let i = 0; i < secondaryCtas.length; i++) {
    const secondaryCta = secondaryCtas[i];
    secondaryCta.addEventListener('click', handleSecondaryCtaClick);
  }
}
